import * as _ from 'lodash'
import React from 'react';
import enums from '../enum';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import validator from '../validator';

import ContactEdit from './contactEdit';
import AddressEdit from './addressEdit';

import contactModel from '../models/contactModel';
import addressModel from '../models/addressModel';

import { PercentInput, PhoneInput, Radio, Section } from './sharedComponents';

class BasicInfo extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.updateModel = this.updateModel.bind(this);
		this.updatePhone = this.updatePhone.bind(this);
	}
	validate (property) {
		const { readOnly } = this.props;

		if (readOnly) { return true;}

		return this.props.vendor.isValid(property);
	}
	updateModel (path, autoSave, e) {
		const { readOnly } = this.props;

		if (readOnly) { return;}

		e.preventDefault();
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}
	updatePhone (phoneType, autoSave, e) {
		const { readOnly } = this.props;

		if (readOnly) { return;}

		const viewValue = e.target.value;

		this.props.updateModel(model => {
			model.setPhoneNumber(phoneType, viewValue);
		}, { autoSave: autoSave });
	}
	render () {
		const { readOnly, vendor } = this.props;

		return (
			<section>
				<header>
					<span>COMPANY</span>
				</header>
				<div className={ readOnly ? 'readOnly' : '' }>
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>Name</strong>
								</td>
								<td className={!this.validate('name') ? 'required' : ''}>
									<input type="text" placeholder="Name" autoCapitalize="" autoCorrect="off" value={vendor.viewValue('name')} onChange={this.updateModel.bind(this, 'name', false)} onBlur={this.updateModel.bind(this, 'name', true)} />
								</td>
								<td />
							</tr>
						</tbody>
					</table>
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>Main Office Phone</strong>
								</td>
								<td className={(!!vendor.workPhoneNumber && !validator.isPhone(vendor.workPhoneNumber)) ? 'required' : ''}>
									<PhoneInput placeholder="Main Office Phone" autoCapitalize="" autoCorrect="off" value={vendor.viewValue('workPhoneNumber')} onChange={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, false)} onBlur={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, true)} />
								</td>
								<td />
							</tr>
							<tr>
								<td />
								<td>
									<strong>Main Office Fax</strong>
								</td>
								<td className={(!!vendor.faxPhoneNumber && !validator.isPhone(vendor.faxPhoneNumber)) ? 'required' : ''}>
									<PhoneInput placeholder="Main Office Fax" autoCapitalize="" autoCorrect="off" value={vendor.viewValue('faxPhoneNumber')} onChange={this.updatePhone.bind(this, enums.phoneNumberTypes.Fax, false)} onBlur={this.updatePhone.bind(this, enums.phoneNumberTypes.Fax, true)}/>
								</td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>
			</section>
		);
	}
}

class VendorTypeSection extends React.Component<any,any> {
	render () {
		const { readOnly, vendor, handleTypeChange } = this.props;
		const allowedTypes = componentServices.routeParams.modulekey === 'retail-sales' ? [enums.vendorTypes.Cabinet_Supplier, enums.vendorTypes.Counter_Supplier, enums.vendorTypes.Outside_Supplier] : [];
		const checklistItems = _.map(allowedTypes, type => {
			const scopeItemButtons = [
				{ classNames: ['icon yes'], isSelected: enums.vendorTypes.isSet(type, vendor.type), value: type, key: `${type}-on` },
				{ classNames: ['icon no'], isSelected: !enums.vendorTypes.isSet(type, vendor.type), value: type, key: `${type}-off` }
			];
			const rowClasses:string[] = [];

			if (enums.vendorTypes.isSet(type, vendor.type)) {
				rowClasses.push('yes');
			}
			else {
				rowClasses.push('no');
			}

			return (
				<tr className={ rowClasses.join(' ') } key={ type }>
					<td />
					<td>
						<Radio buttons={ scopeItemButtons } onChange={ handleTypeChange } />
					</td>
					<td>{ enums.vendorTypes.getDisplayName(type) }</td>
					<td />
				</tr>
			);
		});

		return (<section>
			<header>
				<span>CATEGORIES</span>
			</header>
			<div className={ readOnly ? 'readOnly' : '' }>
				<table className="checklist" cellPadding="0" cellSpacing="0">
					<tbody>
						{ checklistItems }
					</tbody>
				</table>
			</div>
		</section>);
	}
}

const VendorSettings = ({ readOnly = false, updateModel, vendor }) => {
	function update (path, autoSave, e) {
		if (readOnly) { return;}

		e.preventDefault();
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	function validate (property) {
		if (readOnly) { return true;}

		return vendor.isValid(property);
	}

	return (
		<section>
			<header>
				<span>SETTINGS</span>
			</header>
			<div className={ readOnly ? 'readOnly' : '' }>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td>
								<strong>Freight Factor</strong>
							</td>
							<td className={!validate('freightFactor') ? 'required' : ''}>
								<PercentInput placeholder="Freight Factor" value={vendor.viewValue('freightFactor')} onChange={(e) => update('freightFactor', false, e)} onBlur={(e) => update('freightFactor', true, e)} />
							</td>
							<td />
						</tr>
					</tbody>
				</table>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td>
								<strong>Retail Overhead Factor</strong>
							</td>
							<td className={!validate('overheadFactorRetail') ? 'required' : ''}>
								<PercentInput placeholder="Retail Overhead Factor" value={vendor.viewValue('overheadFactorRetail')} onChange={(e) => update('overheadFactorRetail', false, e)} onBlur={(e) => update('overheadFactorRetail', true, e)} />
							</td>
							<td />
						</tr>
						<tr>
							<td />
							<td>
								<strong>Builder Overhead Factor</strong>
							</td>
							<td className={!validate('overheadFactorBuilder') ? 'required' : ''}>
								<PercentInput placeholder="Builder Overhead Factor" value={vendor.viewValue('overheadFactorBuilder')} onChange={(e) => update('overheadFactorBuilder', false, e)} onBlur={(e) => update('overheadFactorBuilder', true, e)} />
							</td>
							<td />
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	);
};

export default class VendorEditOverview extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.updateModel = this.updateModel.bind(this);
		this.validateContact = this.validateContact.bind(this);
		this.validateAddress = this.validateAddress.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
	}

	validateContact (contact, property) {
		return contact.isEmpty() || contact.isValid(property);
	}

	validateAddress (address, property) {
		return address.isEmpty() || address.isValid(property);
	}

	handleTypeChange (newButton) {
		const { vendor, updateModel } = this.props;
		let newType = vendor.type;

		if (enums.vendorTypes.isSet(newButton.value, vendor.type)) {
			newType = enums.vendorTypes.unset(newButton.value, vendor.type);
		}
		else {
			newType = enums.vendorTypes.set(newButton.value, vendor.type);
		}

		updateModel(model => {
			model.type = newType;
		}, { autoSave: true });
	}

	updateModel (path, factory, updater, options) {
		this.props.updateModel(model => {
			let updateTarget = model.getAt(path);

			if (!updateTarget) { // auto-create the child model if it doesn't exist
				updateTarget = factory();
				model.setAt(path, updateTarget);
			}
			updater(updateTarget);
		}, options);
	}

	render () {
		const { updateModel, vendor } = this.props;
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		const companyNameEdit = (<BasicInfo key='vendor.CompanyName' readOnly={ readOnly} vendor={vendor} updateModel={updateModel} />);
		const primaryContactEdit = (<ContactEdit key='vendor.primaryContact' contact={ vendor.primaryContact || contactModel({ priority: 0 }) } title="PRIMARY CONTACT" validate={ this.validateContact } readOnly={ readOnly} updateModel={this.updateModel.bind(this, 'primaryContact', contactModel)} />);
		const billingAddressEdit = (<Section title="ADDRESS"><AddressEdit key='vendor.accountingId' address={ vendor.officeAddress || addressModel() } validate={ this.validateAddress } readOnly={ readOnly} updateModel={this.updateModel.bind(this, 'officeAddress', addressModel)} /></Section>);

		return (
			<div className="contactInfo">
				<section>
					{ companyNameEdit }
					{ primaryContactEdit }
					{ billingAddressEdit }
					<VendorSettings updateModel={ updateModel } vendor={vendor} />
					<VendorTypeSection readOnly={ readOnly} vendor={ vendor } handleTypeChange={ this.handleTypeChange } />
				</section>
			</div>
		);
	}
}